import React, { useContext, useEffect, useState } from 'react';
import { createContext, useRef } from 'react';
import { useReactToPrint, IReactToPrintProps } from 'react-to-print';
type UsePrintRef = any;
/**Prints screen */
type UseHandlePrint = { handlePrint: (options?: Partial<IReactToPrintProps>) => void };

const PrintContext = createContext<any>([]);

const PrintProvider = ({ children }: any) => {
  const [ref, setRef] = useState<React.MutableRefObject<null> | null>(null);
  const [options, setOptions] = useState<any>(null);
  // const [JSX, setJsx] = useState<any>(null);
  const defaultRef = useRef(null);

  const print = useReactToPrint({
    content: () => ref?.current!,
    ...(options && { ...options })
  });

  const handlePrint = (options?: IReactToPrintProps) => {
    setRef(defaultRef);
    if (options) setOptions(options);
    // if (printEl) setJsx(printEl);
  };

  useEffect(() => {
    if (ref) {
      print();
    }

    return () => {
      setRef(null);
      setOptions(null);
    };
    // eslint-disable-next-line
  }, [ref, setRef]);

  return (
    <PrintContext.Provider value={[defaultRef, { handlePrint }]}>
      {children}
      {/* {JSX && (
        <div style={{ display: 'none' }}>
          <div ref={ref}>{JSX}</div>
        </div>
      )} */}
    </PrintContext.Provider>
  );
};

export const usePrint = () => {
  return useContext<[UsePrintRef, UseHandlePrint]>(PrintContext);
};

export default PrintProvider;
